<template>
    <v-card class="mb-12" color="grey lighten-1">
        <template v-for="(linea_group, index) in pedidos">
            <v-card style="margin: 2rem; padding: 1rem">
                <v-tabs>
                    <v-tab>Datos</v-tab>
                    <v-tab>Archivos</v-tab>

                    <v-tab-item>
                        <v-row>
                            <v-col cols="12">
                                <h3>Pedido {{ index + 1 }}</h3>
                            </v-col>
                            <v-col cols="12" md="6">
                                <date-select
                                    label="Fecha pedido"
                                    v-model="linea_group.fecha_pedido"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <date-select
                                    label="Fecha prevista"
                                    v-model="linea_group.fecha_prevista"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    :readonly="linea_group.edit == false"
                                    v-model="linea_group.id_proveedor"
                                    label="Proveedor"
                                    item-value="id"
                                    item-text="nombre"
                                    :items="proveedores"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <dynamic-select
                                    title="Plantilla"
                                    v-bind:estados="plantillas"
                                    show="nombre"
                                    itemvalue="id"
                                    @changeElement="
                                        (val) => changeElement(val, linea_group)
                                    "
                                    @create="savePlantilla"
                                    @delete="deletePlantilla"
                                    @getItem="
                                        (val) => {
                                            plantilla = val;
                                        }
                                    "
                                    @update="savePlantilla"
                                >
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Nombre"
                                                v-model="plantilla.nombre"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Asunto"
                                                v-model="plantilla.asunto"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                label="Plantilla"
                                                v-model="plantilla.descripcion"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </dynamic-select>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    label="Enviar email"
                                    v-model="linea_group.enviar_mail"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="linea_group.asunto_mail"
                                    label="Asunto email"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="linea_group.texto_mail"
                                    label="Texto email"
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    label="Observaciones"
                                    v-model="linea_group.observaciones"
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="6">
                                <h4>Productos</h4>
                            </v-col>
                            <v-col
                                cols="6"
                                style="display: flex; justify-content: end"
                            >
                                <template v-if="linea_group.edit">
                                    <v-btn
                                        v-if="desagrupando != index"
                                        color="red"
                                        class="white--text"
                                        @click="desagrupando = index"
                                        >Desagrupar</v-btn
                                    >
                                    <v-btn
                                        v-else
                                        color="red"
                                        class="white--text"
                                        @click="desagrupando = null"
                                        >Cancelar</v-btn
                                    >
                                    <v-btn
                                        v-if="agrupando != index"
                                        color="success"
                                        @click="agrupando = index"
                                        >Agrupar</v-btn
                                    >
                                    <v-btn
                                        v-else
                                        color="red"
                                        class="white--text"
                                        @click="agrupando = null"
                                        >Cancelar</v-btn
                                    >
                                </template>
                            </v-col>
                            <template
                                v-for="(
                                    linea, index_producto
                                ) in linea_group.lineas"
                            >
                                <v-col cols="12" md="3">
                                    {{ index_producto + 1 }}
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-textarea
                                        v-model="linea.descripcion"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-btn
                                        v-if="
                                            desagrupando == index &&
                                            desagrupando != null
                                        "
                                        color="red"
                                        class="white--text"
                                        @click="
                                            Desagrupar(index, index_producto)
                                        "
                                        >Desagrupar</v-btn
                                    >
                                    <v-btn
                                        v-if="
                                            agrupando != index &&
                                            agrupando != null
                                        "
                                        color="success"
                                        @click="
                                            pedidos[agrupando].lineas.push(
                                                linea
                                            );
                                            agrupando = null;
                                            linea_group.lineas.splice(
                                                index_producto,
                                                1
                                            );
                                            if (linea_group.lineas.length == 0)
                                                pedidos.splice(index, 1);
                                        "
                                        >Agrupar</v-btn
                                    >
                                </v-col>
                            </template>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>
                        <listaArchivos
                            v-on:delete_archivo="
                                (val) => {
                                    deleteArchivo(linea_group, val);
                                }
                            "
                            :items="linea_group.archivo"
                            @subir_file_64="
                                (val) => {
                                    subirArchivo64(linea_group, val);
                                }
                            "
                        ></listaArchivos>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </template>
    </v-card>
</template>
<script>
import listaArchivos from "../../../../components/general/listaArchivos.vue";

export default {
    components: {
        listaArchivos,
    },
    props: ["ordenes", "value"],
    data() {
        return {
            plantilla: {},
            proveedores: [],
            plantillas: [],
            agrupando: null,
            desagrupando: null,
            pedidos: [],
        };
    },
    created() {
        this.getProveedores();
        this.getPlantillas();
        this.pedidosFromOrden();
    },
    watch: {
        value(val) {
            if (val != null) {
                this.pedidos = val;
            }
        },
        pedidos(val) {
            this.$emit("input", val);
        },
        ordenes(val) {
            this.pedidosFromOrden();
        },
    },
    methods: {
        deleteArchivo(pedido, item) {
            pedido.archivo = pedido.archivo.find((element) => element != item);
        },
        subirArchivo64(pedido, data) {
            pedido.archivo.push(data);
        },
        changeElement(val, linea_group) {
            console.log("cambiando");
            console.log(val);
            console.log(linea_group);
            const linea = this.pedidos.find(
                (element) => element == linea_group
            );
            console.log(linea);
            linea.texto_mail = val.descripcion;
            linea.asunto_mail = val.asunto;
            this.pedidos.push({});
            this.pedidos.pop();
        },
        deletePlantilla(id) {
            axios.get(`api/delete-plantilla/${id}`).then((res) => {
                this.getPlantillas();
            });
        },
        savePlantilla() {
            axios.post("api/save-plantillas", this.plantilla).then((res) => {
                this.getPlantillas();
            });
        },
        Desagrupar(index, index_producto) {
            const element = this.pedidos[index].lineas[index_producto];
            const date = new Date();

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            // This arrangement can be altered based on how we want the date's format to appear.
            let currentDate = `${year}-${month}-${day}`;
            this.pedidos.push({
                id_proveedor: null,
                id_orden: element.orden_id,
                fecha_pedido: currentDate,
                fecha_prevista: currentDate,
                lineas: [element],
                total: 0,
            });
            this.pedidos[index].lineas.splice(index_producto, 1);
            if (this.pedidos[index].lineas.length == 0)
                this.pedidos.splice(index, 1);
        },
        pedidosFromOrden() {
            const date = new Date();

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            // This arrangement can be altered based on how we want the date's format to appear.
            let currentDate = `${year}-${month}-${day}`;
            if (this.ordenes != null) {
                this.pedidos = [];

                this.ordenes.forEach((orden) => {
                    let pedido = {
                        edit: true,
                        id_proveedor: null,
                        id_orden: orden.id,
                        fecha_pedido: currentDate,
                        fecha_prevista: null,
                        lineas: [],
                        total: 0,
                        enviar_mail: true,
                        archivo: [],
                    };
                    if (orden.lacado == 1) {
                        const lacado = JSON.parse(JSON.stringify(pedido));
                        lacado.lineas.push({
                            cantidad: 1,
                            descripcion: "lacado",
                            precio: 0,
                            orden_id: orden.id,
                        });
                        lacado.edit = false;
                        lacado.id_proveedor = 8;
                        this.pedidos.push(lacado);
                    }
                    if (orden.taller == 1) {
                        const taller = JSON.parse(JSON.stringify(pedido));
                        taller.lineas.push({
                            cantidad: 1,
                            descripcion: "taller",
                            precio: 0,
                            orden_id: orden.id,
                        });
                        taller.edit = false;
                        taller.id_proveedor = 7;
                        this.pedidos.push(taller);
                    }

                    orden.productos.forEach((producto) => {
                        pedido.lineas.push({
                            cantidad: 1,
                            descripcion:
                                producto.descripcion ??
                                producto.producto.descripcion ??
                                "",
                            precio: 0,
                            orden_id: orden.id,
                        });
                    });
                    this.pedidos.push(pedido);
                });
                this.$emit("input", this.pedidos);
            }
        },
        getProveedores() {
            let me = this;
            axios.get(`api/get-proveedores`).then(
                (res) => {
                    me.proveedores = res.data;
                },
                (res) => {}
            );
        },
        getPlantillas() {
            axios.get(`api/get-plantillas`).then(
                (res) => {
                    this.plantillas = res.data;
                },
                (res) => {}
            );
        },
    },
};
</script>
